export function mergeUserContext (payload, rootState) {
  if (!payload) {
    payload = {}
  }

  // userCurrentContext
  const userCurrentContext = rootState.user.userCurrentContext

  // Add in Org/Group Context
  payload.orgId = _.get(userCurrentContext, 'organization.id')
  payload.groupId = _.get(userCurrentContext, 'group.id')

  return payload
}



// WEBPACK FOOTER //
// ./src/store/helpers.js